module.exports = __webpack_public_path__ + "img/gift6.8a56049d.png";